const domain: string = 'SERVICES'

export const SAVE_SERVICES: string = `${domain}/SAVE_SERVICES`
